export default (name, options = { store: null, initialTab: null }) => ({
    currentTab: null,

    init(){
        if (options.initialTab === null || options.initialTab === undefined) {
            this.currentTab = $(`#${name}-tab-1`);
        } else {
            this.currentTab = $(`#${name}-tab-${options.initialTab}`);
        }

        this.setSliderCss();

        if (options.store !== null && options.store !== undefined) {
            this.$store[options.store].tab = options.initialTab || 1;
        }

        $(window).resize(() => { this.onResize(); });
    },

    onTabClick(tab) {
        if (options.store !== null && options.store !== undefined){
            this.$store[options.store].tab = tab;
        }else{
            this.$dispatch(`${name}:change`, tab);
        }

        this.currentTab = $(`#${name}-tab-${tab}`);

        this.setSliderCss();
    },

	onResize() {
        if (this.currentId) {
            this.setSliderCss();
        }
    },

	setSliderCss() {
        let width = 0;
        let left = 0;
        if (this.currentTab) {
            width = this.currentTab.css('width');
            left = this.currentTab.offset().left - this.currentTab.parent().offset().left;
        }
        const slider = $(`#${name}-cTab-slider`);
        slider.css('width', width);
        slider.css('left', left);
    }
});
